<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable, JtCrud, JtDynamicForm } from 'jtech-webcomps'
import AnalyzeInvoiceSettlementController from './AnalyzeInvoiceSettlementController'
import MainContentLayout from '../service-request/view/Layout/MainContentLayout.vue'
import BlockHeader from '../service-request/view/financial/invoice/component/serviceRequestInvoice/BlockHeader.vue'
import AnalyzeInvoiceSettlementTableHeader from './components/AnalyzeInvoiceSettlementTableHeader.vue'
import ButtonFilter from './components/ButtonFilter.vue'
import InfoBoxPanel from './components/InfoBoxPanel.vue'
import InfoBoxPanelField from './components/InfoBoxPanelField.vue'
import AnalyzeInvoiceSettlementDetail from './AnalyzeInvoiceSettlementDetail.vue'
import { QCheckbox, QTd } from 'quasar'
import ConfirmationModal from './components/ConfirmationModal.vue'
const { modal } = JtCrud

@Component({
  components: {
    QCheckbox,
    QTd,
    JtDataTable,
    MainContentLayout,
    BlockHeader,
    AnalyzeInvoiceSettlementTableHeader,
    ButtonFilter,
    InfoBoxPanel,
    InfoBoxPanelField,
    modal,
    ConfirmationModal,
    JtDynamicForm
  },
  props: {
    name: String,
    params: { type: Object, required: true },
    datatable: { type: Object, required: true },
    forms: { type: Array, required: true },
    selected: Object,
    key: Object
  }
})
export default class AnalyzeInvoiceSettlementPage extends Vue {

}
</script>

<template>
  <div class="full-height">
    <div :class="{
      simpleButtons: rowButtons,
      crudButtons: !rowButtons,
      cleanLayout: cleanLayout
    }" class="row container q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm card-crud">
          <q-card-section class="q-py-sm card-title">
            <div class="crud-title">
              {{ $gettext("APPROVALS") }}
            </div>
          </q-card-section>
          <q-card-section class="tw-justify-center">
            <analyze-invoice-settlement-table-header
              :pending="data.length"
              :api-response="headerItems"
            ></analyze-invoice-settlement-table-header>
          </q-card-section>
          <q-card-section>
            <div class="tw-mt-6 tw-flex tw-space-x-4">

              <button-filter
                v-for="settlementTypeName in displayedSettlementType"
                :key="settlementTypeName"
                :text="settlementType[settlementTypeName].text"
                :color="settlementType[settlementTypeName].color"
                @clickAction="filterInvoice"/>

              <div class="tw-flex-grow"></div>
              <q-btn :disabled="!isAnyItemSelected"
                     @click="showRejectModal = true"
                     class="reproval tw-px-4 tw-py-2tw-text-gray-600 tw-flex tw-items-center tw-space-x-2 tw-text-sm">
                <span><q-icon name="mdi-close" size="24px" />{{ $gettext("REJECT") }} </span>
              </q-btn>
              <q-btn :disabled="!isAnyItemSelected"
                     @click="showApprovalModal = true"
                     class="approval tw-px-4 tw-py-2tw-text-gray-600 tw-flex tw-items-center tw-space-x-2 tw-text-sm">
                <span><q-icon name="mdi-check" size="24px" />{{ $gettext("APPROVE") }} </span>
              </q-btn>
              <q-btn class="filter tw-px-4 tw-py-2 tw-text-gray-600 tw-flex tw-items-center tw-space-x-2 tw-text-sm"
                     flat @click="openModalFilter">
                <q-icon name="filter_list" size="20px" />
                <div class="text-center">{{ $gettext("FILTER") }}</div>
              </q-btn>
            </div>
          </q-card-section>

          <q-card-section class="q-pb-lg card-tab">
            <analyze-invoice-settlement-table-header/>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <confirmation-modal
      :visible="showApprovalModal"
      mode="approve"
      @approve="approve"
      @close="showApprovalModal = false"
    />

    <confirmation-modal
      :visible="showRejectModal"
      mode="deny"
      @deny="deny"
      @close="showRejectModal = false"
    />
    <modal
      v-if="modalFilter.show"
      ref="filterModal"
      :show="modalFilter.show"
      :forms="modalFilter.forms"
      :label="this.$gettext('FILTER')"
      @action-button="actionButtonFilter"
      @input="
        function hideModal() {
          modalFilter.show = false;
        }
      "
    />
  </div>
</template>

<style scoped lang="stylus">

</style>
